import React from 'react';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', className }) => (
  <img
    src="/songlelogocropped.png"
    alt="Songle"
    className={`brand-logo brand-logo--${size}${className ? ` ${className}` : ''}`}
    draggable={false}
  />
);

export default Logo;
